module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter2"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005toc#ch2"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("CHICKEN SPREAD")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Use a food processor to grind up leftover cooked chicken and make it into a smooth spread for crostini or small open-faced cocktail sandwiches.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-space1"
  }, [_vm._v("2 cups cut-up cooked chicken pieces")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 or 3 mushrooms, cut up")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 shallot, chopped, or 2 green onions including some tender green tops, cut up")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 sprig fresh parsley, cut up")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 to 4 tablespoons mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Crostini (toasted baguette) slices for serving (recipe follows)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Place all the ingredients except the baguette slices in a food processor and process until smooth. Scrape down the sides of the bowl as needed. Spread on crostini.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Makes 12 to 14 crostini")]), _vm._v(" "), _c('h4', [_c('strong', [_vm._v("CROSTINI")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Crostini are thin, toasted baguette slices to serve with soups or as a base for hors d’oeuvre toppings.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-space1"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" cup olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 large garlic cloves, quartered")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 baguette, cut into "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v("- to "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("3")]), _vm._v("3-inch slices")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("In a small jar, combine the oil and garlic. Let stand to allow the oil to absorb flavor, about 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('strong', [_vm._v("TO BROIL:")])]), _vm._v(" Preheat the broiler. Arrange the bread slices on a baking sheet and brush them with the garlic oil. Broil on 1 side until toasted, about 1 minute. Turn the slices over and brush with garlic oil. Broil about 40 seconds longer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('strong', [_vm._v("TO BAKE:")])]), _vm._v(" Preheat the oven to 350°F. Arrange the bread slices on a baking sheet and brush both sides with the garlic oil. Bake until lightly browned, about 15 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Makes about 30 slices")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d02c16ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/010-chapter2.vue
// module id = 84
// module chunks = 0